import locale from '../locale/default';
export default locale;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/locale-provider/default.js
// module id = 762
// module chunks = 0